import ModuleNode from "@/components/course/tree/ModuleNode";
import { MiniModuleNode } from "@/components/course/tree/MiniModuleNode";
import CourseFinalQuizEntry from "@/components/course/tree/CourseFinalQuizEntry";
import CourseTreeShell from "@/components/course/tree/CourseTreeShell";
import { useCourseDetailStore } from "@/stores/courseDetailStore";
import { useSyncSelectedCourseNode } from "@/hooks/useSyncSelectedCourseNode";
import { useScrollToElement } from "@/hooks/useScrollToElement";
import { useEnrollmentProgress } from "@/hooks/useEnrollmentProgress";

interface CourseTreeProps {
  showMinimizedSidebar?: boolean;
  onExpandSidebar?: () => void;
}

export const CourseTree = ({
  showMinimizedSidebar,
  onExpandSidebar,
}: CourseTreeProps) => {
  const { courseData, nodeIndex, selectedNodeId, focusedNodeId } =
    useCourseDetailStore();
  const progress = useEnrollmentProgress();

  useSyncSelectedCourseNode();
  useScrollToElement(focusedNodeId ? `node-${focusedNodeId}` : null);

  const activeModuleId = selectedNodeId
    ? (nodeIndex.get(selectedNodeId)?.module?.id ?? null)
    : null;
  const activeLessonTitle = selectedNodeId
    ? nodeIndex.get(selectedNodeId)?.node.title
    : undefined;

  const modules =
    courseData?.structure.filter((node) => node.type === "module") ?? [];

  const renderModuleList = () => {
    if (showMinimizedSidebar) {
      return modules.map((module, moduleIndex) => (
        <MiniModuleNode
          key={module.id}
          module={module}
          moduleIndex={moduleIndex + 1}
          moduleProgress={progress.modules.get(module.id)}
          isActive={module.id === activeModuleId}
          activeLessonTitle={
            module.id === activeModuleId ? activeLessonTitle : undefined
          }
          onExpandSidebar={onExpandSidebar}
        />
      ));
    }

    return modules.map((module, moduleIndex) => (
      <ModuleNode
        key={module.id}
        module={module}
        moduleProgress={progress.modules.get(module.id)}
        chapterProgress={progress.chapters}
        isFirst={moduleIndex === 0}
      />
    ));
  };

  return (
    <CourseTreeShell
      showMinimizedSidebar={showMinimizedSidebar}
      onExpandSidebar={onExpandSidebar}
    >
      {renderModuleList()}
      <CourseFinalQuizEntry />
    </CourseTreeShell>
  );
};
